<!--
  @负责人：libaiqi
  @创建日期：2018-10-09
  @版本号：V1.0.20
  @描述： 配置托管中心
-->
<style>
</style>

<template>
  <div class="uclConfiguration__content">
    <back :history="history"></back>
    <div class="uclConfig__form">
      <el-form ref="form" :model="form" :inline="true" label-width="40px" input-width="auto">
        <el-form-item :label="$t('uclConfig.env')">
          <el-input v-model="form.env"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_search" v-g-rac="gRac('uclConfiguration@search')">{{ $t('uclConfig.search') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_create">{{ $t('uclConfig.create') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="uclConfiguration__table">
      <el-table-extend 
        :data="tData" 
        :head="tHead" 
        :currentChange="tCurrentChange" 
        :sizeChange="tSizeChange" 
        border>
        <template slot="control-column" slot-scope="{data}">
            <el-table-extend-control 
            :control="tableControl" 
            :data="data" 
            :label="$t('common.handle')">
            </el-table-extend-control>
        </template>
      </el-table-extend>
    </div>    
    <el-dialog :closeOnClickModal="false" :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form :model="envForm" label-position="left" label-width="120px" ref="envForm" :rules="rules">
        <el-form-item :label="$t('uclConfig.table.name')" prop="env">
          <el-input v-model="envForm.env"></el-input>
        </el-form-item>
        <el-form-item :label="$t('uclConfig.table.desc')" prop="desc">
          <el-input v-model="envForm.desc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">{{$t('uclConfig.cancle')}}</el-button>
        <el-button type="primary" @click="submitForm" v-g-rac="gRac('uclConfiguration@save')">{{$t('uclConfig.save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import uclConfigBiz from '@/logic/continuousDelivery/uclConfigBiz.js'
  import back from '@/components/back'
  import rac from '@/plugins/rac-mixin.js'
  import table from '@/components/mixins/table'
  import { extend } from '@/utils/tool'
  export default {
    mixins: [rac, table],
    data () {
      const that = this
      return {
        form: {
          env: ''
        },
        history: [],
        dialogTitle: '',
        dialogFormVisible: false,
        envForm: {
          env: '',
          desc: ''
        },
        tableControl: [{
          label: that.$t('common.edit'),
          callback: that.e_edit,
          rac: () => that.gRac('uclConfiguration@edit')
        }],
        rules: {
          env: [
            { required: true, message: that.$t('uclConfig.rules.name'), trigger: 'blur' }
          ],
          desc: [
            { required: true, message: that.$t('uclConfig.rules.desc'), trigger: 'blur' }
          ]
        },
        isAmend: false,
        id: ''
      }
    },
    components: {
      back
    },
    filters: {
    },
    methods: {
      e_init () {
        this.history = []
        this.history.push({ name: this.$t('uclConfig.uclConfig') })
        this.initTable()
        this.search()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'uclConfig.table',
          head: ['name', 'desc', 'createTime', 'updateTime'],
          requestFun: this.search,
          headOpt: {}
        })
      },
      e_search () {
        this.tResetPage()
        this.search()
      },
      search () {
        const reqData = extend(true, { ...this.tPageInfo }, this.form)
        Object.keys(reqData).map((item) => {
          if (reqData[item] === '') {
            delete reqData[item]
          }
        })
        uclConfigBiz.getEnvList(reqData).then((data) => {
          this.tData = data
        })
      },
      resetForm () {
        this.id = ''
        this.dialogTitle = ''
        this.dialogFormVisible = false
        this.$refs.envForm.resetFields()
      },
      submitForm () {
        this.$refs.envForm.validate((valid) => {
          if (valid) {
            let params = new URLSearchParams()
            params.append('env', this.envForm.env)
            params.append('desc', this.envForm.desc)
            if (this.isAmend) {
              uclConfigBiz.editEnv(params, this.id).then((data) => {
                this.$message({
                  message: this.$t('uclConfig.success'),
                  type: 'success'
                })
                this.resetForm()
                this.search()
              }).catch((e) => {
                if (e.success !== 'true') return
                this.$message({
                  message: this.$t('uclConfig.success'),
                  type: 'success'
                })
                this.resetForm()
                this.search()
              })
            } else {
              uclConfigBiz.addEnv(params).then((data) => {
                this.$message({
                  message: this.$t('uclConfig.success'),
                  type: 'success'
                })
                this.resetForm()
                this.search()
              }).catch((e) => {
                if (e.success !== 'true') return
                this.$message({
                  message: this.$t('uclConfig.success'),
                  type: 'success'
                })
                this.resetForm()
                this.search()
              })
            }
          }
        })
      },
      e_create () {
        this.isAmend = false
        this.dialogTitle = this.$t('uclConfig.create')
        this.dialogFormVisible = true
        Object.keys(this.envForm).forEach((item) => {
          this.envForm[item] = ''
        })
      },
      e_edit (row) {
        this.isAmend = true
        this.id = row.id
        this.envForm.env = row.name
        this.envForm.desc = row.desc
        this.dialogTitle = this.$t('uclConfig.edit')
        this.dialogFormVisible = true
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.e_init()
      })
    },
    watch: {

    }

  }
</script>